import React from "react";

interface IProps extends React.PropsWithoutRef<React.SVGAttributes<SVGSVGElement>> {}

export const Chip: React.FC<IProps> = (props) => (
	<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_251_2413)">
			<path
				d="M29.7 17.9784C31.346 9.85932 26.0985 1.94317 17.9793 0.297218C9.86023 -1.34873 1.94408 3.8988 0.298128 12.0179C-1.34782 20.137 3.89971 28.0532 12.0188 29.6991C20.1379 31.3451 28.0541 26.0975 29.7 17.9784Z"
				fill="url(#paint0_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.8952 15.4843L14.9146 15.4648H14.8879V15.4453H14.8708H14.8562V15.4648H14.8318L14.8513 15.4843L14.8343 15.5014H14.8562H14.8879H14.9146L14.8952 15.4843ZM14.8952 15.4843L14.9146 15.4648H14.8879V15.4453H14.8708H14.8562V15.4648H14.8318L14.8513 15.4843L14.8343 15.5014H14.8562H14.8879H14.9146L14.8952 15.4843ZM14.8952 15.4843L14.9146 15.4648H14.8879V15.4453H14.8708H14.8562V15.4648H14.8318L14.8513 15.4843L14.8343 15.5014H14.8562H14.8879H14.9146L14.8952 15.4843ZM14.8952 15.4843L14.9146 15.4648H14.8879V15.4453H14.8708H14.8562V15.4648H14.8318L14.8513 15.4843L14.8343 15.5014H14.8562H14.8879H14.9146L14.8952 15.4843ZM14.8952 15.4843L14.9146 15.4648H14.8879V15.4453H14.8708H14.8562V15.4648H14.8318L14.8513 15.4843L14.8343 15.5014H14.8562H14.8879H14.9146L14.8952 15.4843ZM14.8952 15.4843L14.9146 15.4648H14.8879V15.4453H14.8708H14.8562V15.4648H14.8318L14.8513 15.4843L14.8343 15.5014H14.8562H14.8879H14.9146L14.8952 15.4843ZM29.4543 10.9902C28.567 7.80089 26.6498 4.99464 24.0013 3.00861C21.3529 1.02257 18.1219 -0.0317196 14.8118 0.00998012C11.5017 0.0516798 8.29827 1.18703 5.70069 3.23915C3.1031 5.29128 1.25719 8.14493 0.450539 11.3555C-0.103836 13.5672 -0.146636 15.8761 0.325392 18.1068C0.797421 20.3375 1.77185 22.4312 3.1746 24.2288C4.57734 26.0263 6.37147 27.4803 8.42058 28.4803C10.4697 29.4802 12.7198 29.9999 14.9999 29.9996C17.3108 29.9992 19.5903 29.4649 21.6607 28.4383C23.731 27.4118 25.5362 25.9208 26.9354 24.0816C28.3345 22.2425 29.2898 20.1049 29.7268 17.8357C30.1637 15.5666 30.0705 13.2271 29.4543 10.9999V10.9902ZM22.6534 23.1402C21.3261 24.3885 19.7135 25.293 17.9563 25.775C16.1992 26.257 14.3507 26.3017 12.5723 25.9053C10.7939 25.5089 9.13944 24.6834 7.7533 23.5008C6.36715 22.3182 5.29139 20.8144 4.61985 19.1206C3.94832 17.4268 3.70139 15.5944 3.90062 13.7833C4.09984 11.9721 4.73916 10.2372 5.76282 8.72991C6.78648 7.22257 8.16339 5.98858 9.77345 5.13556C11.3835 4.28253 13.1778 3.83639 14.9999 3.83604C15.9274 3.83434 16.8514 3.94974 17.75 4.1795C20.1573 4.78761 22.2925 6.18262 23.8164 8.14296C25.3403 10.1033 26.1655 12.5166 26.161 14.9996C26.1678 16.5248 25.8598 18.035 25.2563 19.4357C24.6527 20.8365 23.7666 22.0976 22.6534 23.1402ZM14.8952 15.4794L14.9146 15.4599H14.8879V15.4405H14.8708H14.8562V15.4599H14.8318L14.8513 15.4794L14.8343 15.4965H14.8562H14.8879H14.9146L14.8952 15.4794ZM14.8952 15.4794L14.9146 15.4599H14.8879V15.4405H14.8708H14.8562V15.4599H14.8318L14.8513 15.4794L14.8343 15.4965H14.8562H14.8879H14.9146L14.8952 15.4794ZM14.8952 15.4794L14.9146 15.4599H14.8879V15.4405H14.8708H14.8562V15.4599H14.8318L14.8513 15.4794L14.8343 15.4965H14.8562H14.8879H14.9146L14.8952 15.4794ZM14.8952 15.4794L14.9146 15.4599H14.8879V15.4405H14.8708H14.8562V15.4599H14.8318L14.8513 15.4794L14.8343 15.4965H14.8562H14.8879H14.9146L14.8952 15.4794ZM14.8952 15.4794L14.9146 15.4599H14.8879V15.4405H14.8708H14.8562V15.4599H14.8318L14.8513 15.4794L14.8343 15.4965H14.8562H14.8879H14.9146L14.8952 15.4794Z"
				fill="#F9D5D1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.9144 15.5089L14.89 15.5016L14.8949 15.5211L14.8778 15.5064L14.873 15.5332L14.8656 15.5089L14.851 15.5235L14.8559 15.504L14.834 15.5089L14.851 15.4894L14.8315 15.4845L14.851 15.4796L14.8315 15.4602L14.8559 15.4699L14.851 15.4504L14.8656 15.4626L14.873 15.4382L14.8778 15.4626L14.8949 15.4504L14.89 15.4699L14.9144 15.4602L14.8949 15.4796L14.9168 15.4845L14.8949 15.4894L14.9144 15.5089Z"
				fill="url(#paint1_linear_251_2413)"
			/>
			<path
				d="M23.4696 17.0304C24.5919 12.3524 21.7093 7.65037 17.0313 6.52814C12.3533 5.40591 7.65128 8.28845 6.52905 12.9665C5.40682 17.6445 8.28935 22.3465 12.9674 23.4687C17.6454 24.591 22.3474 21.7084 23.4696 17.0304Z"
				fill="#2C001D"
			/>
			<path
				style={{ mixBlendMode: "multiply" }}
				opacity="0.88"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.0004 4.25317C12.8749 4.25317 10.797 4.88347 9.02971 6.06437C7.26237 7.24526 5.8849 8.92371 5.07149 10.8875C4.25807 12.8512 4.04525 15.0121 4.45992 17.0968C4.8746 19.1815 5.89815 21.0964 7.40114 22.5994C8.90414 24.1024 10.8191 25.126 12.9038 25.5407C14.9885 25.9553 17.1494 25.7425 19.1131 24.9291C21.0769 24.1157 22.7553 22.7382 23.9362 20.9709C25.1171 19.2035 25.7474 17.1257 25.7474 15.0002C25.7474 12.1499 24.6151 9.41635 22.5997 7.4009C20.5842 5.38544 17.8507 4.25317 15.0004 4.25317ZM15.0004 24.7753C13.0671 24.7753 11.1772 24.202 9.56967 23.1279C7.96216 22.0538 6.70927 20.5271 5.96941 18.7409C5.22956 16.9548 5.03598 14.9893 5.41315 13.0931C5.79033 11.197 6.72132 9.45521 8.08839 8.08814C9.45546 6.72107 11.1972 5.79008 13.0934 5.41291C14.9896 5.03573 16.955 5.22931 18.7412 5.96916C20.5273 6.70902 22.054 7.96192 23.1281 9.56942C24.2022 11.1769 24.7755 13.0668 24.7755 15.0002C24.7755 17.5927 23.7456 20.079 21.9124 21.9122C20.0793 23.7454 17.5929 24.7753 15.0004 24.7753Z"
				fill="url(#paint2_linear_251_2413)"
			/>
			<path
				style={{ mixBlendMode: "screen" }}
				opacity="0.5"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.0004 4.71558C9.06423 4.71558 4.25342 9.06358 4.25342 14.9998C4.25342 17.85 5.38569 20.5836 7.40114 22.599C9.41659 24.6145 12.1501 25.7467 15.0004 25.7467C17.8507 25.7467 20.5842 24.6145 22.5997 22.599C24.6151 20.5836 25.7474 17.85 25.7474 14.9998C25.7474 9.06358 20.9342 4.71558 15.0004 4.71558ZM14.9152 25.0282C9.51487 25.0282 5.22532 20.4 5.22532 14.9998C5.22532 12.4072 6.2552 9.92091 8.08838 8.08773C9.92157 6.25454 12.4079 5.22467 15.0004 5.22467C17.5929 5.22467 20.0793 6.25454 21.9124 8.08773C23.7456 9.92091 24.7755 12.4072 24.7755 14.9998C24.7755 20.3976 20.313 25.0282 14.9152 25.0282Z"
				fill="url(#paint3_linear_251_2413)"
			/>
			<path
				style={{ mixBlendMode: "multiply" }}
				opacity="0.88"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.22559 10.5328C5.22559 10.5328 8.2631 4.71599 15.0007 4.71599C21.7383 4.71599 25.1752 11.5364 25.1752 11.5364C25.1752 11.5364 22.8466 4.25317 15.0007 4.25317C7.15478 4.25317 5.22559 10.5328 5.22559 10.5328Z"
				fill="url(#paint4_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.4646 29.5955C16.1069 30.1538 13.6491 30.1337 11.3008 29.5371L11.9365 27.0598C12.021 26.7387 12.2205 26.4598 12.4972 26.2761C12.7738 26.0924 13.1083 26.0168 13.437 26.0635C14.3981 26.1959 15.3721 26.2057 16.3357 26.0928C16.6648 26.0496 16.9983 26.1283 17.2734 26.314C17.5485 26.4998 17.746 26.7798 17.8289 27.1012L18.4646 29.5955Z"
				fill="url(#paint5_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.6936 0.460644L18.0651 2.93791C17.9826 3.26085 17.784 3.54203 17.5071 3.72764C17.2303 3.91325 16.8947 3.99025 16.5646 3.94392C15.4641 3.79182 14.3472 3.80166 13.2494 3.97315C12.9116 4.0331 12.5635 3.96328 12.275 3.77766C11.9864 3.59204 11.7785 3.3043 11.6929 2.97201L11.0718 0.536155C13.5655 -0.139964 16.1914 -0.161776 18.696 0.472823L18.6936 0.460644Z"
				fill="url(#paint6_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.46512 24.0955L4.69913 25.9005C2.92269 24.2247 1.58446 22.1388 0.801758 19.8255L3.28633 19.0582C3.59972 18.9629 3.93702 18.9845 4.23575 19.1188C4.53448 19.2532 4.77439 19.4912 4.91105 19.7889C5.33497 20.6822 5.87558 21.5152 6.51871 22.2662C6.73916 22.523 6.85584 22.8529 6.84593 23.1912C6.83601 23.5296 6.70022 23.852 6.46512 24.0955Z"
				fill="url(#paint7_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.4551 10.9904L27.0777 11.7212C26.7503 11.8247 26.3959 11.801 26.0853 11.6547C25.7746 11.5084 25.5306 11.2503 25.4018 10.932C25.0027 9.90884 24.4535 8.9508 23.7722 8.08934C23.5637 7.83024 23.4568 7.50396 23.4716 7.17168C23.4864 6.83939 23.6219 6.52391 23.8526 6.28437L25.6576 4.44043C27.464 6.26213 28.7717 8.51767 29.4551 10.9904Z"
				fill="url(#paint8_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.99956 8.39111C5.36234 9.25647 4.85442 10.2099 4.49177 11.2216C4.37304 11.541 4.13762 11.8036 3.83296 11.9564C3.5283 12.1092 3.17705 12.1408 2.85 12.0449L0.450684 11.3555C1.06114 8.90438 2.28495 6.64872 4.00703 4.80066L5.86072 6.62024C6.09381 6.84889 6.23628 7.15416 6.2618 7.47967C6.28732 7.80519 6.19417 8.12893 5.99956 8.39111Z"
				fill="url(#paint9_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.2768 19.6081C28.5136 21.9701 27.1741 24.1048 25.3794 25.8195L23.5915 24.0633C23.3468 23.821 23.2031 23.4949 23.1895 23.1509C23.176 22.8068 23.2935 22.4704 23.5184 22.2096C24.1797 21.4289 24.7305 20.5609 25.1553 19.63C25.2915 19.3366 25.5282 19.1016 25.8227 18.9675C26.1171 18.8335 26.4498 18.8093 26.7605 18.8993L29.2768 19.6081Z"
				fill="url(#paint10_linear_251_2413)"
			/>
			<g style={{ mixBlendMode: "multiply" }} opacity="0.5">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.5 18.8363C0.5 18.8363 3.50828 29.5249 15.0201 29.4226C27.1312 29.313 29.5403 18.6902 29.5403 18.6902C29.5403 18.6902 27.0119 29.9999 15.0006 29.9999C2.98944 29.9999 0.5 18.8363 0.5 18.8363Z"
					fill="#22006B"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.70332 3.99306C8.70477 4.10995 8.67144 4.22463 8.60755 4.32252C8.54366 4.42042 8.45212 4.49711 8.34454 4.54285C8.23696 4.58858 8.11821 4.60131 8.00339 4.57939C7.88857 4.55748 7.78285 4.50192 7.69968 4.41978C7.6165 4.33764 7.55963 4.23262 7.53629 4.11808C7.51294 4.00354 7.52418 3.88464 7.56858 3.7765C7.61297 3.66836 7.68851 3.57587 7.7856 3.51076C7.88269 3.44566 7.99695 3.4109 8.11385 3.41089C8.26893 3.41088 8.41777 3.47198 8.52811 3.58095C8.63845 3.68992 8.7014 3.83799 8.70332 3.99306Z"
				fill="url(#paint11_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.8078 3.99306C21.8093 4.10995 21.7759 4.22463 21.712 4.32252C21.6482 4.42042 21.5566 4.49711 21.449 4.54285C21.3415 4.58858 21.2227 4.60131 21.1079 4.57939C20.9931 4.55748 20.8873 4.50192 20.8042 4.41978C20.721 4.33764 20.6641 4.23262 20.6408 4.11808C20.6174 4.00354 20.6287 3.88464 20.6731 3.7765C20.7175 3.66836 20.793 3.57587 20.8901 3.51076C20.9872 3.44566 21.1014 3.4109 21.2183 3.41089C21.3732 3.41151 21.5217 3.47281 21.6319 3.58165C21.7421 3.69049 21.8053 3.83819 21.8078 3.99306Z"
				fill="url(#paint12_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.29272 26.3361C9.29272 26.4526 9.25815 26.5666 9.19338 26.6636C9.12861 26.7605 9.03654 26.836 8.92883 26.8807C8.82112 26.9253 8.70259 26.937 8.58825 26.9142C8.4739 26.8915 8.36886 26.8353 8.28642 26.7529C8.20398 26.6704 8.14784 26.5654 8.1251 26.4511C8.10235 26.3367 8.11403 26.2182 8.15864 26.1105C8.20326 26.0028 8.27881 25.9107 8.37575 25.8459C8.47269 25.7812 8.58666 25.7466 8.70325 25.7466C8.85959 25.7466 9.00952 25.8087 9.12007 25.9192C9.23062 26.0298 9.29272 26.1797 9.29272 26.3361Z"
				fill="url(#paint13_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.6038 26.4955C21.6033 26.612 21.5683 26.7257 21.5032 26.8223C21.4382 26.9189 21.3459 26.9941 21.2382 27.0383C21.1304 27.0826 21.012 27.0939 20.8978 27.0709C20.7836 27.0479 20.6788 26.9915 20.5966 26.909C20.5144 26.8265 20.4585 26.7214 20.436 26.6072C20.4134 26.4929 20.4252 26.3745 20.4699 26.2669C20.5146 26.1593 20.5901 26.0674 20.687 26.0027C20.7839 25.9381 20.8978 25.9036 21.0143 25.9036C21.1708 25.9042 21.3208 25.9669 21.4312 26.0778C21.5417 26.1887 21.6038 26.3389 21.6038 26.4955Z"
				fill="url(#paint14_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.3103 15.4847C28.3108 15.602 28.2764 15.7168 28.2115 15.8145C28.1467 15.9122 28.0543 15.9885 27.946 16.0336C27.8378 16.0787 27.7185 16.0906 27.6035 16.0678C27.4885 16.0451 27.3828 15.9886 27.2998 15.9057C27.2169 15.8228 27.1605 15.7171 27.1377 15.6021C27.115 15.487 27.1269 15.3678 27.172 15.2595C27.2171 15.1513 27.2933 15.0589 27.391 14.994C27.4888 14.9292 27.6035 14.8948 27.7208 14.8953C27.8771 14.8953 28.0271 14.9574 28.1376 15.0679C28.2482 15.1785 28.3103 15.3284 28.3103 15.4847Z"
				fill="url(#paint15_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.56322 15.531C2.5637 15.6482 2.52939 15.7629 2.46465 15.8605C2.3999 15.9582 2.30763 16.0344 2.19951 16.0796C2.0914 16.1248 1.97231 16.1368 1.85733 16.1143C1.74235 16.0917 1.63665 16.0355 1.55363 15.9528C1.4706 15.8702 1.41398 15.7647 1.39095 15.6498C1.36791 15.5349 1.37949 15.4158 1.42422 15.3075C1.46895 15.1992 1.54481 15.1066 1.6422 15.0415C1.73959 14.9763 1.85413 14.9415 1.9713 14.9415C2.12787 14.9415 2.27805 15.0036 2.38899 15.114C2.49992 15.2245 2.56257 15.3744 2.56322 15.531Z"
				fill="url(#paint16_linear_251_2413)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.1871 15.4867C15.1871 15.4867 15.1725 17.5377 13.7476 18.2416H16.6292C15.2042 17.5377 15.1871 15.4867 15.1871 15.4867Z"
				fill="white"
			/>
			<path
				d="M15.2504 14.4008C16.2177 14.4008 17.0018 13.6167 17.0018 12.6495C17.0018 11.6822 16.2177 10.8981 15.2504 10.8981C14.2831 10.8981 13.499 11.6822 13.499 12.6495C13.499 13.6167 14.2831 14.4008 15.2504 14.4008Z"
				fill="white"
			/>
			<path
				d="M13.6874 16.708C14.6547 16.708 15.4388 15.9238 15.4388 14.9566C15.4388 13.9893 14.6547 13.2052 13.6874 13.2052C12.7202 13.2052 11.936 13.9893 11.936 14.9566C11.936 15.9238 12.7202 16.708 13.6874 16.708Z"
				fill="white"
			/>
			<path
				d="M16.7109 16.708C17.6781 16.708 18.4622 15.9238 18.4622 14.9566C18.4622 13.9893 17.6781 13.2052 16.7109 13.2052C15.7436 13.2052 14.9595 13.9893 14.9595 14.9566C14.9595 15.9238 15.7436 16.708 16.7109 16.708Z"
				fill="white"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_251_2413"
				x1="-0.00192706"
				y1="14.9998"
				x2="29.9956"
				y2="14.9998"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F9D5D1" />
				<stop offset="0.06" stopColor="#FAD7D2" />
				<stop offset="0.53" stopColor="#FEE3DB" />
				<stop offset="1" stopColor="#FFE7DE" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_251_2413"
				x1="14.8535"
				y1="15.5259"
				x2="14.89"
				y2="15.448"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#A02EDC" />
				<stop offset="1" stopColor="#2F042F" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_251_2413"
				x1="15.0004"
				y1="25.7472"
				x2="15.0004"
				y2="4.25317"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.02" stopColor="white" />
				<stop offset="0.99" stopColor="#D863B3" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_251_2413"
				x1="15.0004"
				y1="25.7467"
				x2="15.0004"
				y2="4.71558"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#A188B0" />
				<stop offset="0.01" stopColor="#9880A6" />
				<stop offset="0.08" stopColor="#74627F" />
				<stop offset="0.14" stopColor="#55485D" />
				<stop offset="0.22" stopColor="#3A3140" />
				<stop offset="0.3" stopColor="#251F28" />
				<stop offset="0.4" stopColor="#141116" />
				<stop offset="0.51" stopColor="#090709" />
				<stop offset="0.66" stopColor="#020202" />
				<stop offset="0.99" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_251_2413"
				x1="13.6001"
				y1="14.4253"
				x2="18.177"
				y2="4.57958"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D6A2C4" />
				<stop offset="0.99" stopColor="#7E0045" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_251_2413"
				x1="14.9034"
				y1="30.7574"
				x2="14.2214"
				y2="-6.64269"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D9023D" />
				<stop offset="1" stopColor="#FF131D" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_251_2413"
				x1="15.4344"
				y1="30.7481"
				x2="14.7524"
				y2="-6.65206"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D9023D" />
				<stop offset="1" stopColor="#FF131D" />
			</linearGradient>
			<linearGradient
				id="paint7_linear_251_2413"
				x1="3.99516"
				y1="30.9573"
				x2="3.31313"
				y2="-6.44524"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D9023D" />
				<stop offset="1" stopColor="#FF131D" />
			</linearGradient>
			<linearGradient
				id="paint8_linear_251_2413"
				x1="26.8536"
				y1="30.5406"
				x2="26.1716"
				y2="-6.86194"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D9023D" />
				<stop offset="1" stopColor="#FF131D" />
			</linearGradient>
			<linearGradient
				id="paint9_linear_251_2413"
				x1="3.74883"
				y1="30.9617"
				x2="3.06679"
				y2="-6.44082"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D9023D" />
				<stop offset="1" stopColor="#FF131D" />
			</linearGradient>
			<linearGradient
				id="paint10_linear_251_2413"
				x1="26.4025"
				y1="30.5475"
				x2="25.7204"
				y2="-6.85259"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D9023D" />
				<stop offset="1" stopColor="#FF131D" />
			</linearGradient>
			<linearGradient
				id="paint11_linear_251_2413"
				x1="-0.833052"
				y1="25.9206"
				x2="11.5874"
				y2="-4.52026"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2C001D" />
				<stop offset="1" stopColor="#39103E" />
			</linearGradient>
			<linearGradient
				id="paint12_linear_251_2413"
				x1="10.3983"
				y1="30.5049"
				x2="22.8211"
				y2="0.0640247"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2C001D" />
				<stop offset="1" stopColor="#39103E" />
			</linearGradient>
			<linearGradient
				id="paint13_linear_251_2413"
				x1="7.48775"
				y1="29.3151"
				x2="19.9106"
				y2="-1.12579"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2C001D" />
				<stop offset="1" stopColor="#39103E" />
			</linearGradient>
			<linearGradient
				id="paint14_linear_251_2413"
				x1="18.0961"
				y1="33.6447"
				x2="30.5166"
				y2="3.2038"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2C001D" />
				<stop offset="1" stopColor="#39103E" />
			</linearGradient>
			<linearGradient
				id="paint15_linear_251_2413"
				x1="19.9943"
				y1="34.4187"
				x2="32.4147"
				y2="3.97776"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2C001D" />
				<stop offset="1" stopColor="#39103E" />
			</linearGradient>
			<linearGradient
				id="paint16_linear_251_2413"
				x1="-2.06247"
				y1="25.4181"
				x2="10.3604"
				y2="-5.02274"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2C001D" />
				<stop offset="1" stopColor="#39103E" />
			</linearGradient>
			<clipPath id="clip0_251_2413">
				<rect width="30" height="30" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
